import { useContext } from 'react';

import { UserContext } from '~/auth/userContext';
import { useFeatureFlags } from '~/utils/featureFlags';
import { canAccess, CAPTURE_KNOWLEDGE } from '~/utils/role';

export function useTasksEnabled(): boolean {
  const { tasks } = useFeatureFlags();
  const { userDetails } = useContext(UserContext);
  return tasks && canAccess(userDetails.role, CAPTURE_KNOWLEDGE);
}
